import { User } from 'app/user/types'

type InitialsUser = Pick<User, 'firstName' | 'lastName'> & Partial<Pick<User, 'email'>>

export const getInitials = (user: InitialsUser) => {
  const initials = [user.firstName, user.lastName]
    .map((name) => name?.charAt(0).toUpperCase())
    .filter(Boolean)
    .join('')

  if (initials) return initials

  return user.email?.charAt(0).toUpperCase() ?? ''
}
